import * as api from '../../services/attendee'
import lodash from 'lodash'

export const FETCH_ATTENDEES = 'FETCH_ATTENDEES';
export const FETCH_ATTENDEE = 'FETCH_ATTENDEE';
export const FETCH_TASKS = 'FETCH_TASKS';
export const FETCH_ATTENDEESPRINT = 'FETCH_ATTENDEESPRINT';
export const FETCH_ATTENDEELEVELSHARE = 'FETCH_ATTENDEELEVELSHARE';


export const fetchAttendee = (evtId, id) => ({
    type: FETCH_ATTENDEE,
    payload: {
        promise: api.findAttendee({eventId: evtId, attendeeId: id})
    }
});


export const fetchAttendees = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ATTENDEES,
        payload: {
            promise: api.findAttendees(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'shareCode','textFieldId','textFieldValue'),
            sort: sort,
            extra: extra
        }
    };
};

export const fetchTasks = (params, pagination, sort, extra) => {

    return {
        type: FETCH_TASKS,
        payload: {
            promise: api.findTasks(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};

export const fetchAttendeesPrint = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ATTENDEESPRINT,
        payload: {
            promise: api.findAttendees(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchAttendeeLevelShare = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ATTENDEELEVELSHARE,
        payload: {
            promise: api.findAttendeeLevelShare(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: lodash.omit(params, 'levelTwo'),
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/attendee.js